import { Component, Renderer2, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Authentication, CartService } from '../../providers';
import { SigninComponent } from '../signin/signin';
import { ForgotPasswordComponent } from '../forgot_password/forgot_password';
import { CartModalComponent } from '../+utils';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';

@Component({
  selector: 'header_component',
  styleUrls: ['./header.scss'],
  templateUrl: './header.pug'
})

export class HeaderComponent {
  public Logo = require('../../resources/images/logo.png');
  public currentUser = JSON.parse(window.localStorage.getItem('currentUser'));
  public cartData = JSON.parse(window.localStorage.getItem('cartOrder'));
  cartCounter: number;
  urlName: string;

  constructor(private authService: Authentication,
              private cartService: CartService,
              private router: Router,
              private modalService: NgbModal,
              private renderer: Renderer2,
              private route: ActivatedRoute) {}

  ngOnInit(){
    this.getUrlName();
    this.authService.userUpdated.subscribe(
      (user: Object) => {
        this.currentUser = user; }
    );

    this.cartCounter = this.cartService.itemsCount;

    this.cartService.cartChanged.subscribe(
      (data: Object) => {
        this.cartData = data; }
    );

    this.router.events.forEach((event) => {
      if(event instanceof NavigationEnd) {
        $('#account-menu-checkbox').prop('checked', false);
        this.urlName = '';
        this.getUrlName();
      }
    })
  }

  openSignIn() {
    const modalRef = this.modalService.open(SigninComponent, { windowClass: 'signin-modal' });
    modalRef.result.then((data) => {
      if(data == 'forgot password') {
        this.openForgotPassword();
      }
    }, () => {});
  }

  openForgotPassword() {
    this.modalService.open(ForgotPasswordComponent, { windowClass: 'signin-modal forgot-password-modal' });
  }

  openCartModal() {
    this.modalService.open(CartModalComponent, { windowClass: 'cart-modal', backdrop: false });
  }

  public toggleMenu() {
    let menuOpened = document.body.classList.contains('sidemenu-open');
    if (menuOpened) {
      this.renderer.removeClass(document.body, 'sidemenu-open');
    } else {
      this.renderer.addClass(document.body, 'sidemenu-open');
    }
  }

  public logOut() {
    this.authService.logOut();
  }

  getUrlName() {
    let routeChild = this.route.snapshot.firstChild;
    if(routeChild && routeChild.children.length) {
      this.urlName = routeChild.firstChild.data['name'];
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/header/header.ts